import rehypeParse from "rehype-parse";
import rehype2remark from "rehype-remark";
import remarkGfm from "remark-gfm";
import remarkStringify from "remark-stringify";
import { unified } from "unified";
const pipeline = unified()
    .use(rehypeParse)
    .use(rehype2remark)
    .use(remarkGfm)
    .use(remarkStringify);
export const htmlToMarkdown = pipeline.process.bind(pipeline);
//# sourceMappingURL=htmlToMarkdown.js.map